export default "__VITE_ASSET__B34EbtPG__"